import type { QuestionnaireState } from "../../types";

export const handleClearAsyncErrorAction = (
  state: QuestionnaireState,
  payload: string, // question name
): QuestionnaireState => {
  const { [payload]: _, ...remainingAsyncErrors } = state.asyncErrors || {};

  return {
    ...state,
    asyncErrors: remainingAsyncErrors,
  };
};
